import { useActiveOrgSmartAccountsSetup } from '~/hooks/org'

export const useRequiredActiveOrgSmartAccountsSetup = () => {
  const setup = useActiveOrgSmartAccountsSetup()
  if (!setup) {
    throw new Error('Active org smart accounts setup required.')
  }
  return setup
}
